import * as React from 'react';
import styled, { css } from 'styled-components';

export interface DeleteIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  noHover?: boolean;
  isRedIcon?: boolean;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const DeleteIcon: React.FC<DeleteIconProps> = ({
  className,
  noHover,
  isRedIcon,
  onClick,
  ...props
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    className={`${className || ''} ${isRedIcon ? 'red-icon' : ''}`}
    onClick={onClick}
    {...props}
  >
    <path
      className="circle"
      d="M10 0L10 0c5.5 0 10 4.5 10 10l0 0c0 5.5-4.5 10-10 10l0 0C4.5 20 0 15.5 0 10l0 0C0 4.5 4.5 0 10 0z"
    />
    <path
      className="line"
      d="M10.7 10l1.7-1.6c0.2-0.2 0.2-0.5 0-0.7s-0.5-0.2-0.7 0L10 9.3 8.4 7.7c-0.2-0.2-0.5-0.2-0.7 0s-0.2 0.5 0 0.7L9.3 10l-1.6 1.7c-0.2 0.2-0.2 0.5 0 0.7 0.1 0.1 0.2 0.2 0.4 0.2s0.3 0 0.4-0.1L10 10.7l1.7 1.7c0.1 0.1 0.2 0.2 0.4 0.2s0.3 0 0.4-0.1c0.2-0.2 0.2-0.5 0-0.7L10.7 10z"
    />
  </svg>
);

export default styled(DeleteIcon)`
  .circle,
  .line {
    transition: fill
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};
  }
  .circle {
    fill: ${({ theme }) => theme.colors.accentLight};
  }

  .line {
    fill: ${({ theme }) => theme.colors.accent};
  }

  ${(props) =>
    props.noHover
      ? css`
          cursor: auto;

          .circle {
            fill: ${({ theme }) => theme.colors.accent};
          }
          .line {
            fill: ${({ theme }) => theme.colors.accentLight};
          }
        `
      : css`
          cursor: pointer;

          &:hover {
            .circle {
              fill: ${({ theme }) => theme.colors.accent};
            }
            .line {
              fill: ${({ theme }) => theme.colors.accentLight};
            }
          }
        `}

  &.red-icon {
    .circle {
      fill: ${({ theme }) => theme.colors.accent};
    }

    .line {
      fill: ${({ theme }) => theme.colors.white};
    }

    &:hover {
      .circle {
        fill: ${({ theme }) => theme.colors.accentLight};
      }

      .line {
        fill: ${({ theme }) => theme.colors.accent};
      }
    }
  }
`;
